import { render, staticRenderFns } from "./FooterModern.vue?vue&type=template&id=4659b9ad&"
import script from "./FooterModern.vue?vue&type=script&lang=js&"
export * from "./FooterModern.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BrandingLogoIcon: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Branding/LogoIcon.vue').default,Section: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Section/Index.vue').default,BrandingIcon: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Branding/Icon.vue').default,FormCookieSettings: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Form/CookieSettings.vue').default,Menu: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Menu/index.vue').default,Section: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Section/Index.vue').default})
